import { useCallback } from "react";
import { chinaContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const PRICE_SCALE = 10 ** 8;

export async function fetchTokenPriceUsd(contract, tokenAddress) {
  const buy = await contract.methods.getLatestPrice(tokenAddress).call();
  const px = Number(buy[0]) / PRICE_SCALE;
  return Number.isFinite(px) && px > 0 ? px : 0;
}

export default function useTokenPrice() {
  const web3 = new Web3(Environment.rpc);
  const contract = chinaContract(Environment.presaleContract, web3);

  const getTokenPriceUsd = useCallback(
    async (tokenAddress) => fetchTokenPriceUsd(contract, tokenAddress),
    [contract],
  );

  return { getTokenPriceUsd };
}
